import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GenericGridSmartViewsDataProviderFactory } from '../factory/GenericGridSmartViewsDataProviderFactory';
import {
  SmartViewItemConfiguration,
  SmartViewsCreateRequest,
  SmartViewsRecentCreateRequest,
  SmartViewState,
  SmartViewsUpdateRequest,
  StateGetResponse,
} from '../types';
import { ValidateViewNameResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GenericGridSmartViewsBaseDataProvider } from '../dataProvider/GenericGridSmartViewsBaseDataProvider';

export class GenericGridSmartViewsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GenericGridSmartViewsDataProviderFactory;
  public dataProvider: GenericGridSmartViewsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GenericGridSmartViewsDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<Array<SmartViewItemConfiguration>> {
    return await this.dataProvider.getDataForView();
  }

  async readViews(componentName) {
    return await this.dataProvider.readViews(componentName);
  }

  async addCustomView(componentName: string, details: SmartViewsCreateRequest): Promise<SmartViewItemConfiguration> {
    return await this.dataProvider.addCustomView(componentName, details);
  }

  async updateCustomView(
    componentName: string,
    updatedView: SmartViewsUpdateRequest
  ): Promise<SmartViewItemConfiguration> {
    return await this.dataProvider.updateCustomView(componentName, updatedView);
  }

  async deleteCustomView(componentName: string, id: string) {
    return await this.dataProvider.deleteCustomView(componentName, id);
  }

  async addRecentView(componentName: string, details: SmartViewsRecentCreateRequest) {
    return await this.dataProvider.addRecentView(componentName, details);
  }

  async validateViewName(componentName: string, name: string): Promise<ValidateViewNameResponse> {
    return await this.dataProvider.validateViewName(componentName, name);
  }

  async updateRecentView(
    componentName: string,
    id: string,
    details: SmartViewsUpdateRequest
  ): Promise<SmartViewItemConfiguration> {
    return await this.dataProvider.updateRecentView(componentName, id, details);
  }

  async addToFavorite(componentName: string, id: string) {
    return await this.dataProvider.addToFavorite(componentName, id);
  }

  async removeFromFavorite(componentName: string, id: string) {
    return await this.dataProvider.removeFromFavorite(componentName, id);
  }

  async getSmartViewSettings(name: string): Promise<SmartViewState> {
    return Ext.state.Manager.get(name, { selectedViewId: null });
  }

  async upsertState(name: string, settings: object): Promise<any> {
    return Ext.state.Manager.set(name, settings);
  }
}
